module.exports = __webpack_public_path__ + "static/media/white-restart.49d7efbf.svg";